// extracted by mini-css-extract-plugin
export default {"title":"Naa-z","warning":"Oaa-z","sizeOptionsLegendText":"Paa-z"};